import * as time from "./time";

// KTT Functionality Stuff
// ======================================================
export function _HTML_comment(comment: string): string {
  // parse links etc
  return comment;
}

export function _HTML_mood(mood: []): string {
  return mood
    .filter((mood) => [])
    .map((num) => `<mood lv="${num}">${num}</mood>`)
    .join("");
}

// export function getAllCommentsForTagAndDay(date, tag) {
//   // receives js date object
//   // receives tag string
//   // gets the log entry for that date
//   // goes through each entry that has that tag
//   // adds each comment into an array
//   date = dateNoTime(date)

//   let timestamp = []
//   let comments = []
//   let dataArray = []
//   let entries = logObj.fullLogNoTime[date].entries

//   entries = entries.map(each => {
//     if (each.tags.includes(tag)) {
//       let comment = capitalizeString(string.sanitize(each.comment))
//       let dataString = comment.match(window.regExes.JSON) ? comment.match(window.regExes.JSON)[0] : ''
//       comment = comment.replace(dataString, '')

//       if (each.start != undefined) {
//         dataString = `<time>${each.start}</time> <keydata>${dataString}</keydata>`
//       }

//       if (comment != '') {
//         comments.push(`<comment>${comment}</comment>`)
//       }
//       if (dataString != '') {
//         dataArray.push(dataString)
//       }
//     }
//   })
//   let pop = { comments: comments.join(" "), dataArray: dataArray }
//   // console.log(pop)
//   return pop
// }

export function filterDayObjByTag(dayObj: any, tag_name: string): [] {
  const filtered = Object.entries(dayObj.habits).filter((x: any) => x[0] == tag_name);

  if (filtered.length <= 0) {
    return [];
  }

  return filtered[0][1].data;
}

// function getEntriesByTag(tag) {
//   // for a given tag, return an object with all the [date].entries that contain this tag

//   return Object.entries(logObj.fullLogNoTime).filter(entry => {
//     let entry_list = Object.entries(entry[1].summary)

//     let new_list = entry_list.filter(each => {
//       if (each[0].includes(tag)) { return entry }
//     })

//     if (new_list.length > 0) { return entry }
//   })
// }

// export function getLatestDateWithTag(tag) {
//   for (let x = 0; x < Object.entries(logObj.fullLogDesc).length; x++) {
//     let date = Object.entries(logObj.fullLogDesc)[x]
//     let does_date_have_tag

//     let tag_list = Object.entries(date[1][1].summary)
//     does_date_have_tag = tag_list.some(array => {
//       return array.includes(tag)
//     })

//     if (does_date_have_tag === true) {
//       return dateNoTime(date[1][0])
//     }
//   }
// }
